export const selectionsReducer = (state = {loading: true, resultselection: null, selections: null, selection: null, precandidates: [], precandidatesLoading: false, descriptionByAI: null, IALoading: false, selectionGoTo: null } , action) => {
    switch (action.type) {
        case 'SELECTION_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                selections: action.payload
            }
        case 'SELECTION_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                selection: action.payload.selection
            }
        case 'SELECTION_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultselection: action.payload
            }
        case 'SELECTION_EDIT_SUCCESS':
            return {
                ...state,
                loading: false,
                selection: action.payload.selection ? action.payload.selection : state.selection,
                resultselection: action.payload.message
            }
        case 'SELECTION_DESCRIPTION_GET_SUCCESS':
            return {
                ...state,
                IALoading: false,
                descriptionByAI: action.payload.description
            }
        case 'SELECTION_CLONE_SUCCESS':
            return {
                ...state,
                loading: false,
                resultselection: action.payload.message,
                selectionGoTo: action.payload.selection
            }
        case 'SELECTION_ADD_PRECANDIDATE_SUCCESS':
            return {
                ...state,
                loading: false,
                resultselection: action.payload.message,
                selections: state.selections.filter(s => s._id !== action.payload.selection._id)
            }
        case 'SELECTION_REMOVE_PRECANDIDATE_SUCCESS':
            return {
                ...state,
                loading: false,
                resultselection: action.payload.message,
                selections: state.selections.filter(s => s._id !== action.payload.selection._id)
            }
        case 'SELECTION_RESET_RESULT':
            return {...state,
                resultselection: null
            }
        case 'SELECTION_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'SELECTION_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'SELECTION_IA_LOADING':
            return {
                ...state,
                IALoading: true
            }
        case 'SELECTION_IA_NOT_LOADING':
            return {
                ...state,
                IALoading: false
            }
        case 'SELECTION_PRECANDIDATES_LOADING':
            return {
                ...state,
                precandidatesLoading: true
            }
        case 'SELECTION_PRECANDIDATES_GET_SUCCESS':
            return {
                ...state,
                precandidatesLoading: false,
                precandidates: action.payload
            }
        case 'SELECTION_PRECANDIDATES_NOT_LOADING':
            return {
                ...state,
                precandidatesLoading: false
            }
        case 'SELECTION_MORE_PRECANDIDATES_GET_SUCCESS':
            return{
                ...state,
                precandidatesLoading: false,
                precandidates: [...state.precandidates, ...action.payload]
            }
        default:
            return state
    }
}

